//
//
//
//
//
//
//
//
//
//
//
//
//

var changed = 'changed';
export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return { isOpen: this.opened };
  },

  model: {
    prop: 'opened',
    event: changed
  },
  watch: {
    opened: function opened(newValue, oldValue) {
      this.isOpen = newValue;
    }
  },
  methods: {
    close: function close() {
      // this.opened = false
      this.$emit(changed, false);
      this.isOpen = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/toast.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/toast.vue
// module chunks = 13 14 16 17 37 38